

export default ($api) => (
  {
    khuCongNghiep: (data) => {
      return $api.get(`khu-cong-nghiep-page`, { params: data })
    },
  })
